import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native-web';

import Image from '../../shared/Image';

import './OffsetBorderBox.module.scss';

export default function OffsetBorderBox({
  children,
  borderOffset,
  borderPosition,
  borderColor,
  backgroundColor,
  backgroundImage,
  backgroundImageStyle,
}) {
  return (
    <View styleName={`box box--${borderPosition} box--${borderOffset}-offset box--border-color--${borderColor}`}>
      <View styleName={`box__color box__color--${borderPosition} box__color--${backgroundColor}-background box__color--${borderOffset}-offset`}>
        {backgroundImage && (
          <Image
            styleName="box__image"
            source={backgroundImage}
            style={backgroundImageStyle}
          />
        )}
      </View>
      <View styleName="box__inner">
        {children}
      </View>
    </View>
  );
}

OffsetBorderBox.propTypes = {
  /** The children components */
  children: PropTypes.any.isRequired,
  /** The border position */
  borderOffset: PropTypes.oneOf([
    'small',
    'medium',
  ]),
  borderPosition: PropTypes.oneOf([
    'top-right',
    'top-left',
    'bottom-right',
    'bottom-left',
  ]),
  borderColor: PropTypes.oneOf([
    'black',
    'blue',
  ]),
  backgroundColor: PropTypes.oneOf([
    'black',
    'blue',
    'pink',
    'taupe',
    'gray',
    'white',
  ]),
  backgroundImage: PropTypes.any,
  backgroundImageStyle: PropTypes.any,
};

OffsetBorderBox.defaultProps = {
  borderPosition: 'top-right',
  borderColor: 'black',
  backgroundColor: 'blue',
  borderOffset: 'medium',
  backgroundImage: undefined,
  backgroundImageStyle: {},
};
